import { Modal } from 'antd';
import { setCurrUTourUrl } from 'features/siteMapSlice';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';

const UTourModal = () => {
  // Redux Hooks and States
  const dispatch = useAppDispatch();
  const { currUTourUrl } = useAppSelector((state) => ({
    currUTourUrl: state.siteMap.currUTourUrl!,
  }));

  // Functions
  const handleClose = () => {
    dispatch(setCurrUTourUrl(''));
  };

  return (
    <Modal
      title="U-Tour"
      width={'95%'}
      centered
      visible={true}
      footer={null}
      onCancel={handleClose}
      bodyStyle={{ padding: 0 }}
    >
      <iframe
        data-cy="u-tour-iframe"
        title="U-Tour"
        src={currUTourUrl}
        width="100%"
        height={window.innerHeight * 0.8}
        frameBorder="0"
      />
    </Modal>
  );
};

export default UTourModal;
